/**
 * Pulls a human-readable message out of a failed API call.
 *
 * Identical to the copy in components/Locations/apiError.utils.ts — kept
 * here too so this folder is self-contained. If you'd rather share one
 * copy, move it to components/apiError.utils.ts and update both imports.
 */
export function getApiErrorMessage(e: any, fallback: string): string {
    const data = e?.response?.data;
    if (typeof data === "string" && data.trim()) return data;
    if (data && typeof data.message === "string" && data.message.trim()) return data.message;

    if (typeof e?.data === "string" && e.data.trim()) return e.data;
    if (typeof e?.body === "string" && e.body.trim()) return e.body;

    if (typeof e?.message === "string" && e.message.trim()) return e.message;

    return fallback;
}
